import { GenericModal } from '@/components/modals';

import { TIME_NOT_BOOKED_ERROR_MODAL } from '../constants';

interface Props {
  onModalAccept: () => void;
  onModalDecline: () => void;
  skipDeclineHandlerOnDismiss?: boolean;
}

// Todo: combine this and time released modal in one component, they are the same
export const TimeNotBookedErrorModal = ({
  onModalAccept,
  onModalDecline,
  skipDeclineHandlerOnDismiss,
}: Props): JSX.Element => {
  return (
    <GenericModal
      name={TIME_NOT_BOOKED_ERROR_MODAL}
      label=""
      acceptButtonText="Refresh" // Todo: add translation
      declineButtonText="Doctor's Profile" // Todo: add translation
      handleModalAccept={onModalAccept}
      handleModalDecline={onModalDecline}
      skipDeclineHandlerOnDismiss={skipDeclineHandlerOnDismiss}
    >
      {/* Todo: add translation */}
      <h3 className="mb-4">Error during booking, please try again.</h3>
      {/* Todo: add translation */}
      <p>We are redirecting your screen to give you the most up-to-date times.</p>
    </GenericModal>
  );
};
